import tab from "../../TabContainer/Tab";

export const myCustomCellEditFunctionInBuyFactor = (dataStateplz, setDataStateplz, cell, field, value) => {


  const tableData = [...dataStateplz]
  debugger
  const stringStoreId = "na_707"
  const stringProductId = "na_31";
  const storeId = cell.getData()[stringStoreId];

  const ProductId = cell.getData()[stringProductId];

  tableData.forEach(row => {

    if (row[stringProductId] === ProductId && row[stringStoreId] === storeId) {
      row[field] = value

    }

    setDataStateplz(tableData)
  })
}
export const calculateSumOfEachRowInFactor = (tableData) => {

  const totalKey = "total";
  const priceKey = "na_88";
  const numberKey = "na_318";
  const discountKey = "na_261";


  const tempArray = [];
  tableData.forEach(row => {
    row[totalKey] = (row[priceKey] - row[discountKey]) * row[numberKey]
    tempArray.push(row)
  })

  return tempArray

}

export const deleteRowHandlerInFactor = (cell, dataStateplz) => {

  console.log(dataStateplz)
  debugger
  const storeIdKey = "na_707";
  const productIdKey = "na_32";
  const productId = cell.getData()[productIdKey];
  const storeId = cell.getData()[storeIdKey];


  const table = [...dataStateplz]
  table.forEach((row, index) => {
    if (row[productIdKey] === productId && row[storeIdKey] === storeId) {
      table.splice(index, 1);
    }
  })
  return table
}

export const sumOfTotalPricesInTable = (table) => {

  let sum = 0;
  table.forEach(row => {
    sum += row.total
  })

  return sum;

}

